export default __webpack_public_path__ + "static/media/HSL_TARMO_2021.04cf8c74.pdf";